<div class="menu-category-item" [class.no-image]="!hasValidImage() || isImageError()" (click)="onProductClick()">
    <!-- Card body: iOS CustomRoundedShape10 (right-inset 15, top slopes down), drawn as SVG so it themes. -->
    <svg class="menu-card-bg" viewBox="0 0 400 120" preserveAspectRatio="none" aria-hidden="true">
        <path d="M 0,10 Q 0,0 9.99,0.52 L 375.01,19.48 Q 385,20 385,30 L 385,110 Q 385,120 375,120 L 10,120 Q 0,120 0,110 Z"
              fill="var(--menu-item-background, #252525)"
              stroke="var(--menu-image-border, #2B2B2B)" stroke-width="1"
              vector-effect="non-scaling-stroke" />
    </svg>
    <!-- Products without a valid image render as a text-only card (iOS parity): the image tile is omitted. -->
    <div class="product-image" *ngIf="hasValidImage() && !isImageError()">
        <!-- Plain <img> shown at its natural ratio (object-fit: contain) in a themed rounded tile —
             same treatment as the recommended (most-ordered) cards, so images show consistently. -->
        <img [src]="getProductImageSrc()" alt="" (load)="onImageLoad()" (error)="onImageError()"
             [style.opacity]="isImageLoaded() ? 1 : 0" />
        <div class="image-placeholder" *ngIf="!isImageLoaded()">
            <div class="spinner"></div>
        </div>
    </div>

    <div class="menu-category-item-info">
        <div>
            <h3>{{ getProductName() }}</h3>
            <div class="product-description" [innerHTML]="getProductDescription()"></div>
        </div>
        <!-- Price and, under it, the combinations hint — iOS VerticalItemView keeps both in the
             leading column, chip below the money. The wrapper is what stops the chip becoming a
             third child of a space-between column and floating away from the price it belongs to. -->
        <div class="price-block">
            <h4 *ngIf="!product.on_sale">
                {{ product.regular_price | price }} <span [innerHTML]="currencySymbol"></span>
                <span class="second-price" style="display: block;" *ngIf="isSecondCurrencyActive() && getSecondPrice(product.regular_price)">
                    {{ getSecondPrice(product.regular_price) }} <span [innerHTML]="getSecondCurrencySymbol()"></span>
                </span>
            </h4>
            <h4 *ngIf="product.on_sale">
                {{ product.sale_price | price }} <span [innerHTML]="currencySymbol"></span>
                <span class="original-price">{{ product.regular_price | price }}</span>
                <div style="display: flex; align-items: center; gap: 4px;">
                    <span class="second-price" *ngIf="isSecondCurrencyActive() && getSecondPrice(product.sale_price)">
                        {{ getSecondPrice(product.sale_price) }} <span [innerHTML]="getSecondCurrencySymbol()"></span>
                    </span>
                    <span class="second-price second-regular-price" *ngIf="isSecondCurrencyActive() && getSecondPrice(product.regular_price)">
                        {{ getSecondPrice(product.regular_price) }} <span [innerHTML]="getSecondCurrencySymbol()"></span>
                    </span>
                </div>
            </h4>
            <!-- The full-width tile has room for the wording, which is what makes the chip
                 self-explanatory. Only ever shown for a dish the guest holds under 2+ selections. -->
            <app-supplement-combinations-badge *ngIf="combinationCount > 1"
                [count]="combinationCount"
                (tapped)="onCombinationsTap($event)">
            </app-supplement-combinations-badge>
        </div>
    </div>

    <div class="quantity-controls" *ngIf="isInCart && orderingEnabled">
        <button (click)="onQuantityChange($event, -1)" aria-label="minus">
            <svg class="pill-glyph" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path d="M3.42383 9H15.7988" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </button>
        <!-- The SUM across every line of this dish: two cheese pizzas and one bacon pizza is three
             pizzas ordered. The "n combinations" chip below the price is what keeps that readable. -->
        <span>{{ quantityInCart }}</span>
        <button (click)="onQuantityChange($event, 1)" aria-label="plus">
            <svg class="pill-glyph" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path d="M3.42383 9H15.7988" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M9.61133 2.8125V15.1875" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
        </button>
    </div>
    <button class="add-to-cart-button-first" *ngIf="!isInCart && orderingEnabled"
        (click)="onAddToCart($event)" aria-label="plus">
        <svg class="pill-glyph" viewBox="0 0 19 18" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path d="M3.42383 9H15.7988" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M9.61133 2.8125V15.1875" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
    </button>
</div>
